import axios from "axios";

// Create axios instance with default config
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || "http://localhost:5000",
  timeout: import.meta.env.VITE_API_TIMEOUT || 10000,
  headers: {
    "Content-Type": "application/json"
  }
});

// Request interceptor - no auth token needed for public voting
// Device ID is handled in the vote submission, not headers
api.interceptors.request.use(
  (config) => {
    // Optional: Add device ID to headers if needed for tracking
    // For now, deviceId is sent in the request body for votes
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Log detailed error information for debugging
    console.error("❌ API Error:", {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      message: error.message,
      code: error.code
    });

    if (error.response?.status === 401) {
      // Handle unauthorized (shouldn't happen for public endpoints)
      console.error("Unauthorized access");
    }

    // Handle network errors (no response from server)
    if (!error.response) {
      console.error("❌ Network error - no response from server. Check if backend is running.");
    }

    return Promise.reject(error);
  }
);

export default api;
